import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'ptl-date-input',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './date-input.component.html',
  styleUrls: ['./date-input.component.scss'],
})
export class DateInputComponent {
  value = input('');
  disabled = input(false);
  min = input<string | null>(null);
  max = input<string | null>(null);
  valueChange = output<string>();

  onInput(event: Event): void {
    this.valueChange.emit((event.target as HTMLInputElement).value);
  }
}
